import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  removeEntityConfigurationItem,
  selectOrganicRanksAdditionalInfo,
  setKeysToDelete,
  updateEntityConfigurationItem,
} from '../../../../../../../../store/slice/organicRankModal'

export const useListItem = ({ id, currentFixedBid, currentBidFactorInit, searchPhrase, type }) => {
  const [isFixedBid, setIsFixedBid] = useState(currentFixedBid.fixedBid_exact && currentFixedBid.fixedBid_phrase)
  const { isBol } = useSelector(selectOrganicRanksAdditionalInfo)

  const fixedBidExact = currentFixedBid.fixedBid_exact
  const fixedBidPhrase = currentFixedBid.fixedBid_phrase
  const fixedBidBoard = currentFixedBid.fixedBid_board

  const dispatch = useDispatch()

  const deleteItem = useCallback(() => {
    dispatch(removeEntityConfigurationItem(id))

    if (type !== 'keyword_temp') {
      dispatch(
        setKeysToDelete({
          searchPhrase,
          delete: 1,
        })
      )
    }
  }, [type, searchPhrase])

  const updateBidFactor = (v) => {
    dispatch(
      updateEntityConfigurationItem({
        id,
        data: {
          currentBidFactor: v,
        },
      })
    )
  }

  const updateFixedBidValue = (key, value) => {
    dispatch(
      updateEntityConfigurationItem({
        id,
        data: {
          currentFixedBid: {
            ...currentFixedBid,
            [key]: value,
          },
        },
      })
    )
  }

  const changeBidMode = useCallback(
    (isFixed) => {
      if (!isFixed) {
        dispatch(
          updateEntityConfigurationItem({
            id,
            data: {
              currentFixedBid: {
                ...currentFixedBid,
                fixedBid_exact: null,
                fixedBid_phrase: null,
              },
              currentBidFactor: currentBidFactorInit || 0,
            },
          })
        )
      } else {
        dispatch(
          updateEntityConfigurationItem({
            id,
            data: {
              currentFixedBid: {
                ...currentFixedBid,
                fixedBid_exact: currentFixedBid.fixedBid_exact_init,
                fixedBid_phrase: currentFixedBid.fixedBid_phrase_init,
              },
              currentBidFactor: null,
            },
          })
        )
      }
    },
    [currentFixedBid]
  )

  return {
    isFixedBid,
    setIsFixedBid,
    deleteItem,
    updateBidFactor,
    fixedBidExact,
    fixedBidPhrase,
    fixedBidBoard,
    updateFixedBidValue,
    changeBidMode,
    isBol,
  }
}
